import { render, staticRenderFns } from "./role-permission-settings.vue?vue&type=template&id=60ddba72&scoped=true&"
import script from "./role-permission-settings.vue?vue&type=script&lang=js&"
export * from "./role-permission-settings.vue?vue&type=script&lang=js&"
import style0 from "./role-permission-settings.vue?vue&type=style&index=0&id=60ddba72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddba72",
  null
  
)

export default component.exports